import NextLink, { LinkProps } from "next/link";
import React from "react";
import { NormalTypes } from "../../../utils/prop-types";

type Props = {
  type?: NormalTypes;
  loading?: boolean;
  disabled?: boolean;
  htmlType?: React.AnchorHTMLAttributes<any>["type"];
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
  linkProps?: LinkProps;
};

const defaultProps = {
  type: "default" as NormalTypes,
  htmlType: "a" as React.AnchorHTMLAttributes<any>["type"],
  loading: false,
  disabled: false,
  className: "",
};

type NativeAttrs = Omit<React.AnchorHTMLAttributes<any>, keyof Props>;
export type CustomLinkProps = Props & typeof defaultProps & NativeAttrs;

const GeistLink: React.FC<React.PropsWithChildren<CustomLinkProps>> = ({
  linkProps,
  disabled,
  htmlType,
  onClick,
  children,
}) => {
  const link = (
    <a
      type={htmlType}
      role={htmlType === "a" ? "a" : "button"}
      className={`${
        disabled
          ? "text-gray-500"
          : "text-gray-600 hover:text-black cursor-pointer"
      } text-sm font-medium transition-colors duration-200 ease-out `}
      onClick={(e) => htmlType !== "a" && onClick && onClick(e)}
    >
      {children}
    </a>
  );
  if (htmlType === "a" && linkProps) {
    const { href, as, shallow, replace, locale } = linkProps;
    return (
      <NextLink
        href={href}
        as={as}
        shallow={shallow}
        replace={replace}
        locale={locale}
        passHref
      >
        {link}
      </NextLink>
    );
  }

  return link;
};

type MemoBadgeComponent<P = {}> = React.NamedExoticComponent<P>;
type ComponentProps = Partial<typeof defaultProps> &
  Omit<Props, keyof typeof defaultProps> &
  NativeAttrs;

GeistLink.defaultProps = defaultProps;

export default React.memo(GeistLink) as MemoBadgeComponent<ComponentProps>;
